import React, { useState } from 'react';
import { icons } from '@ublend-npm/aulaui-next';
import { ProviderImage } from './LtiProviderIcon.styled';

export type LtiProviderIconProps = {
  iconUrl?: string;
  altText?: string;
};

export const LtiProviderIcon = ({ iconUrl, altText }: LtiProviderIconProps) => {
  const [iconFailed, setIconFailed] = useState(false);

  return iconUrl && !iconFailed ? (
    <ProviderImage
      src={iconUrl}
      alt={altText}
      onError={() => setIconFailed(true)}
    />
  ) : (
    <icons.ExtensionIcon data-testid="extension-icon" />
  );
};
